import { translateBackend } from '@assets/i18n/config';
import type { TranslatedString } from '@interfaces/shared';
import type { SxProps, Theme } from '@mui/material';
import InfoDialog from '@ovComponents/2-component/infoDialog/infoDialog';
import { Box, Typography, useTheme } from 'hephaestus/web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type DisclaimerOptions = {
  contentDescriptionBanner: TranslatedString;
  contentDescriptionTitle: TranslatedString;
  contentDescription: TranslatedString;
};

export default function Disclaimer({
  options,
  sx,
}: {
  options: DisclaimerOptions;
  sx?: SxProps<Theme>;
}) {
  const theme = useTheme();

  if (
    !options?.contentDescriptionBanner &&
    !options?.contentDescriptionTitle &&
    !options?.contentDescription
  )
    return <></>;

  return (
    <Box
      sx={[
        {
          pb: 2,
          mb: 2,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant='bodyMedium' sx={{ fontWeight: 500 }}>
          <ReactMarkdown
            className='markdown'
            remarkPlugins={[remarkGfm]}
            linkTarget='_blank'
          >
            {translateBackend(options.contentDescriptionBanner)}
          </ReactMarkdown>
        </Typography>
        <InfoDialog
          title={translateBackend(options.contentDescriptionTitle)}
          information={translateBackend(options.contentDescription)}
          dialogSx={{
            '.MuiDialog-container': {
              alignItems: 'flex-start',
              paddingTop: 2,
              '.MuiDialogTitle-root': { border: 'none' },
              '.MuiDialogContent-root': {
                paddingTop: '0px !important',
                '.MuiTypography-root': { m: 0, pb: 2 },
              },
            },
          }}
          center
        />
      </Box>
      <Box
        sx={{
          borderBottom: `2px solid ${theme.color.neutralPressed}`,
          position: 'absolute',
          bottom: 0,
          left: { xs: -16, sm: -32 },
          right: { xs: -16, sm: -32 },
          zIndex: 1000,
        }}
      />
    </Box>
  );
}
